import React from 'react'
import { useParams } from 'react-router-dom'
import { SegmentQueryBuilder } from '../../components/segment-query-builder'
import { SegmentBuilderNotice } from '../../components/segment-query-builder/segment-builder-notice'
import { tryParseInt } from '../../_utils/try-parse'
import { getPathEntityId } from '../../_utils/get-path-entity-id'
import { PageHeader } from '@pushly/aqe/lib/components'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'
import { getQueryStringParam } from '../../_utils/get-query-string'

const Segment = () => {
    const appSvc = useService(AppService)
    const { segmentId } = useParams<{ segmentId: string; template: string }>()
    const pathSegmentId = tryParseInt(segmentId)

    const templateId = getQueryStringParam('template', tryParseInt)

    const pathOrgId = getPathEntityId('organization')
    const pathDomainId = getPathEntityId('domain')

    const level: 'org' | 'domain' = pathOrgId ? 'org' : 'domain'
    const builderProps: any = {}
    if (pathOrgId) {
        builderProps.level = 'org'
        builderProps.orgId = pathOrgId
    } else {
        builderProps.level = 'domain'
        builderProps.domainId = pathDomainId
    }

    const titleMode = pathSegmentId ? 'Edit' : 'Create'
    const titleEntity = pathOrgId ? 'Multi-Domain Segment' : 'Segment'

    const leaveBuilder = () => appSvc.routeWithin(level, '/segments')

    return (
        <div>
            <PageHeader title={`${titleMode} ${titleEntity}`} onTitleSet={appSvc.customizeTabTitle} />

            <SegmentQueryBuilder
                segmentId={pathSegmentId}
                templateId={templateId}
                onSaved={leaveBuilder}
                onCancel={leaveBuilder}
                // Only this surface announces the new builder. The same component renders inside a
                // notification drawer, a journey audience and an app message, and a reader who is part
                // way through sending something is not there to read release notes.
                notice={<SegmentBuilderNotice />}
                {...builderProps}
            />
        </div>
    )
}

export default Segment
